import { CREATE_APPOINTMENT, CREATE_APPOINTMENT_ERROR, CREATE_APPOINTMENT_SUCCESS, PAYMENT_CONFIRMED, PAYMENT_CONFIRMED_ERROR, PAYMENT_CONFIRMED_SUCCESS, REQUEST_PAYMENT, REQUEST_PAYMENT_ERROR, REQUEST_PAYMENT_SUCCESS } from './Constants';

export const createAppointmentRequest = (payload, patientId) => ({
    type: CREATE_APPOINTMENT,
    payload : payload,
    patientId : patientId
});
export const createAppointmentRequestSuccess = (data) => ({
    type: CREATE_APPOINTMENT_SUCCESS,
    data : data
});
export const createAppointmentRequestError = () => ({
    type: CREATE_APPOINTMENT_ERROR
});

export const paymentRequest = (payload, scheduleData) => ({
    type: REQUEST_PAYMENT,
    payload : payload,
    scheduleData : scheduleData
});
export const paymentRequestSuccess = (data) => ({
    type: REQUEST_PAYMENT_SUCCESS,
    data : data
});
export const paymentRequestError = () => ({
    type: REQUEST_PAYMENT_ERROR
});

export const paymentConfirmedRequest = (payload, scheduleData) => ({
    type: PAYMENT_CONFIRMED,
    payload : payload,
    scheduleData : scheduleData
});
export const paymentConfirmedRequestSuccess = (data) => ({
    type: PAYMENT_CONFIRMED_SUCCESS,
    data : data
});
export const paymentConfirmedRequestError = () => ({
    type: PAYMENT_CONFIRMED_ERROR
});